<template>
    <b-icon :icon="icon" font-scale="1" :variant="variant"/>
</template>

<script>
export default {
    name: "MaterialIcon",

    props: {
        file: File
    },

    computed: {
        icon() {
            if (!this.file) {
                return 'file-earmark'
            }

            if (this.file.type.includes('pdf')) {
                return 'file-pdf'
            }

            if (this.file.type.includes('video')) {
                return 'camera-video'
            }

            return 'file-earmark'
        },

        variant() {
            if (!this.file) {
                return 'secondary'
            }

            if (this.file.type.includes('pdf')) {
                return 'danger'
            }

            if (this.file.type.includes('video')) {
                return 'primary'
            }

            return 'dark'
        }
    }
}
</script>